import { useEffect, useState } from "react";
import { motion } from "framer-motion";

const TARGET = new Date("2026-12-05T20:00:00");
const pad = (n) => String(n).padStart(2, "0");

export const Countdown = () => {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(t);
  }, []);

  const diff = TARGET - now;
  if (diff <= 0) return null;

  const cells = [
    [Math.floor(diff / 86400000), "days"],
    [Math.floor((diff % 86400000) / 3600000), "hrs"],
    [Math.floor((diff % 3600000) / 60000), "min"],
    [Math.floor((diff % 60000) / 1000), "sec"],
  ];

  return (
    <motion.div
      initial={{ opacity: 0, y: 16 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 1.9, duration: 0.9 }}
      className="mt-10"
      data-testid="hero-countdown"
    >
      <p className="mb-4 text-[10px] uppercase tracking-[0.3em] text-[#666666]">
        The surprise lands in
      </p>
      <div className="flex gap-6 md:gap-10">
        {cells.map(([value, label]) => (
          <div key={label} className="flex flex-col items-start" data-testid={`countdown-${label}`}>
            <span className="font-display text-3xl font-light tabular-nums text-gold md:text-5xl">
              {pad(value)}
            </span>
            <span className="mt-1 text-[10px] uppercase tracking-[0.25em] text-[#A1A19A]">{label}</span>
          </div>
        ))}
      </div>
    </motion.div>
  );
};
